import { z } from 'zod';

/**
 * Custom Reasoning Schema
 *
 * Validates data-custom-reasoning SSE events from backend.
 * These events represent AI reasoning steps during response generation.
 */
export const CustomReasoningSchema = z.object({
  type: z.literal('custom-reasoning'),
  version: z.string(),
  thought: z.string(),
  timestamp: z.string(), // ISO 8601 timestamp
  metadata: z.object({
    requestId: z.string(),
  }).optional(),
});

export type CustomReasoning = z.infer<typeof CustomReasoningSchema>;

/**
 * Safely parse custom reasoning data
 *
 * @param json - Unknown JSON data from backend
 * @returns Parsed reasoning object or null if invalid
 */
export function safeParseCustomReasoning(json: unknown): CustomReasoning | null {
  const result = CustomReasoningSchema.safeParse(json);
  return result.success ? result.data : null;
}
